import React from "react";
import { ArrowUpRight } from "lucide-react";
import { PROBLEM_CARDS } from "../../data/mock";

export default function Problem() {
  return (
    <section className="bg-cream grain px-5 md:px-8 py-20 lg:py-28">
      <div className="max-w-[1240px] mx-auto">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div>
            <p className="font-mono text-[12px] uppercase tracking-[0.18em] text-teal">
              01 <span className="text-navy/40">—</span> The problem
            </p>
            <h2 className="mt-5 font-grotesk font-bold text-navy leading-[1.02] tracking-tight text-[clamp(2.25rem,4.5vw,3.75rem)]">
              A missed call doesn't wait for morning.
            </h2>
          </div>
          <div className="lg:pt-16">
            <p className="text-navy/70 text-lg leading-relaxed">
              It becomes someone else's customer. CallRetrieve protects the moments when demand arrives faster than your team can respond.
            </p>
            <a
              href="#contact"
              className="group mt-6 inline-flex items-center gap-2 bg-navy text-cream font-medium pl-5 pr-4 py-2.5 rounded-full hover:bg-navy-800 transition-colors"
            >
              Protect your next call
              <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </a>
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-5">
          {PROBLEM_CARDS.map((c, i) => (
            <div
              key={i}
              className="group bg-white rounded-3xl border border-navy/8 p-8 hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
            >
              <span className="font-mono text-[13px] text-teal">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="mt-4 font-grotesk text-xl font-semibold text-navy leading-snug">{c.title}</h3>
              <p className="mt-3 text-navy/60 leading-relaxed">{c.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
